import * as React from "react";
const Star = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.5,4 L9.729,9.069 L4,10.112 L8.015,14.287 L7.248,19.999 L12.5,17.512 L17.753,20 L16.986,14.287 L21.001,10.112 L15.272,9.069 L12.5,4 Z M9.087,13.942 L6.032,10.764 L10.391,9.971 L12.5,6.114 L14.61,9.971 L18.969,10.764 L15.914,13.942 L16.498,18.289 L12.5,16.397 L8.502,18.29 L9.087,13.942 Z" }));
Star.displayName = "Star";
var Star_default = Star;
export {
  Star_default as default
};
